var e=function(e){return e&&Date.parse(e)?new Date(e).toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"}):null};export{e as f};
//# sourceMappingURL=formatDate.js.map
